<template>
  <div class="item">
    <div style="display: flex; flex-direction: column;">
      <span class="content">{{ name }}</span>
      <span class="remark" style="margin-top: -5px;">{{ remark }}</span>
    </div>
    <div class="number" style="margin-left: 10px;">
      <input
        class="input"
        :type="dtype"
        :placeholder="placeholder"
        v-model="inputValue"
        @keyup.enter="save"
        :disabled = isDisabled
      />
    </div>
    <a class="save" v-show="saveIconStatus" @click="save()"
        ><font-awesome-icon icon="save"
      /></a>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    "font-awesome-icon": FontAwesomeIcon
  },
  props: {
    code: String,
    name: String,
    value: [String, Number],
    placeholder: String,
    dbTable: String,
    remark: String,
    isDisabled: Boolean,
    dtype: {
      type: String,
      default: function() {
        return "text";
      }
    }
  },
  data() {
    return {
      type: "string",
      inputValue: this.value
    };
  },
  computed: {
    saveIconStatus() {
      return this.value !== this.inputValue;
    }
  },
  methods: {
    save: function() {
      console.log("save");
      if (this.inputValue !== this.value) {
        this.$emit('input', this.inputValue);
        this.$emit("update-input", {
          code: this.code,
          name: this.name,
          dbTable: this.dbTable,
          mutation: this.inputValue,
          origin: this.value,
          type: this.type,
          warning: this.saveIconStatus
        });
      }
    },
    emitEditStatusEventToParent() {
      let changeStatusData = {
        code: this.code,
        warning: this.saveIconStatus
      };
      this.$emit('change-edit-status', changeStatusData)
    }
  },
  watch: {
    saveIconStatus: function(newVal, oldVal) {
      this.emitEditStatusEventToParent();
    }
  }
};
</script>
<style scoped src="../../../src/assets/css/shop-console.css"></style>
